








import Chart from 'chart.js/auto';
import { ChartDataset, ChartOptions, ScatterDataPoint } from 'chart.js';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import annotationPlugin from 'chartjs-plugin-annotation';
import 'chartjs-adapter-moment';

import ChartHelper from "@/core/ChartHelper";

Chart.register(annotationPlugin);

@Component
export default class LineChartComponent extends Vue {
  @Prop({required: true}) private deliveries!: ScatterDataPoint[];
  @Prop({required: true}) private options!: ChartOptions;
  @Prop({required: true}) private labels!: moment.Moment[];
  @Prop({required: true}) private labelsData!: string;
  @Prop({default: false}) private drawTrendline!: boolean;
  isLoading: boolean = true;
  private chart!: Chart;
  datasets: ChartDataset[]= [];

  mounted() {
    this.getDataset()
    this.plot();
    this.chart.render;
  }

  @Watch('deliveries')
  update(): void {
    this.getDataset()
    this.plot();
  }

 getDataset() {
    const newDataset : ChartDataset[] =  [{
        type: this.drawTrendline || this.labelsData == "Bølgepapp" ? 'scatter' : 'line',
        label: this.labelsData,
        backgroundColor: 'transparent',
        pointBackgroundColor: this.labelsData == "Bølgepapp" ? '#2262a64d' : '#222b385b',
        borderColor: this.labelsData == "Fuktighet" ? '#2b385b' : '#62a64d',
        data: this.deliveries,
        tension: 0.05,
        spanGaps: true,
        pointRadius: this.labelsData == "Bølgepapp" ? 5 : undefined
    }];

    if (this.drawTrendline){
      newDataset.unshift({
          type: 'line',
          label: "Trend",
          backgroundColor: 'transparent',
          pointBackgroundColor: 'red',
          borderColor: "blue",
          data: ChartHelper.getRegressionOnDataset(this.deliveries),
          tension: 0.4,
          spanGaps: true,
          pointRadius: 0,
          pointHitRadius: 0,
      })
    }

    if (this.labelsData == "Plast") {
      this.datasets = newDataset;
      return;
    }

    newDataset.push({
      type: 'scatter',
      label: this.labelsData == "Fuktighet" ? "Grenseverdi" : "Grenseverdier",
      backgroundColor: 'transparent',
      pointBackgroundColor: '#2b385b',
      borderColor:  "red",
      data: [],
    });

    this.datasets = newDataset;
  }

plot(): void {
    const canvas: any = this.$refs.canvas;
    //clear the chart instance before create a new one
    if (this.chart != null) this.chart.destroy();
    this.chart = new Chart(canvas.getContext('2d'), {
      type: 'scatter',
      data: {
        labels: this.labels,
        datasets: this.datasets,
      },
      options: this.options
    });
    this.isLoading = false;
  }
}
